import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewEncapsulation,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IContactFilters } from 'app/interfaces/contact.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import moment from 'moment';

@Component({
	selector: 'contacts-table-filters-sidebar',
	templateUrl: './contacts-table-filters-sidebar.component.html',
	styleUrls: ['./contacts-table-filters-sidebar.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ContactsTableFiltersSidebarComponent implements OnInit, OnChanges {
	public selectedFilters = 0;
	public contactFilterForm: FormGroup;
	public cachedFormValue;
	public daysBeforeEventDate?: string;
	public cachedDaysBeforeEventDate: string;
	public isFormClean = false;
	public wasFiltered = false;
	@Input() professionalType: string;

	@Input()
	public isOpen = false;

	@Output()
	public onCloseSidebar: EventEmitter<void> = new EventEmitter();

	@Output()
	public onFilter: EventEmitter<IContactFilters> = new EventEmitter<IContactFilters>();

	@Output()
	public onChangeQuantity: EventEmitter<number> = new EventEmitter<number>();

	constructor(
		public formBuilder: FormBuilder,
		public actionTrackerService: ActionTrackerService
	) {}

	public ngOnInit(): void {
		this.contactFilterForm = this.formBuilder.group({
			hasPromptuaryRegistered: new FormControl(undefined),
			lastEventDateBefore: new FormControl(undefined),
			levels: new FormArray([]),
		});

		this.contactFilterForm.valueChanges.subscribe((formValue) => {
			this.countSelectedFilters(formValue);
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.isOpen && changes.isOpen.currentValue) {
			this.isFormClean = false;
			this.actionTrackerService.eventTracker(
				SCOPE_TYPE.Account,
				SUBSCOPE_TYPE.List,
				ITEM_TYPE.Filter,
				INTERACTION_TYPE.Open
			);
		}
	}

	public onChangeDaysBeforeEventDate(daysBeforeEventDate: number): void {
		this.contactFilterForm.controls.lastEventDateBefore.setValue(
			moment().subtract(daysBeforeEventDate, 'day').toDate().toISOString()
		);
	}

	public closeSidebar(): void {
		if (this.isFormClean) {
			this.cancelFormClear();
		}
		this.onCloseSidebar.emit();
		this.onChangeQuantity.emit(this.selectedFilters);
	}

	public countSelectedFilters(formValue) {
		this.selectedFilters = 0;
		for (const key in formValue) {
			if (formValue[key] instanceof Array) {
				this.selectedFilters += formValue[key].length;
				return;
			}

			if (formValue[key] !== null) {
				this.selectedFilters++;
			}
		}
	}

	public cancelFormClear() {
		if (this.cachedFormValue && this.wasFiltered) {
			this.cachedFormValue.levels?.forEach((level) => {
				(this.contactFilterForm.controls.levels as FormArray).push(
					new FormControl(level)
				);
			});
			this.contactFilterForm.setValue(this.cachedFormValue);
			this.daysBeforeEventDate = this.cachedDaysBeforeEventDate;
		}
	}

	public clear(): void {
		this.cachedDaysBeforeEventDate = this.daysBeforeEventDate;
		this.cachedFormValue = this.contactFilterForm.value;
		this.isFormClean = true;
		this.contactFilterForm.reset();
		const levels = this.contactFilterForm.get('levels') as FormArray;
		while (levels.length !== 0) {
			levels.removeAt(0);
		}
		this.daysBeforeEventDate = undefined;
	}

	public apply(): void {
		Object.keys(this.contactFilterForm.value).forEach((key) => {
			if (this.contactFilterForm.value[key] && key !== 'levels') {
				this.trackDefautFilters(key);
				return;
			}
			if (key === 'levels') {
				this.trackBaselineLevelsFilter();
			}
		});

		this.wasFiltered = this.selectedFilters > 0;

		this.onFilter.emit(this.contactFilterForm.value as IContactFilters);
		this.onCloseSidebar.emit();
		this.onChangeQuantity.emit(this.selectedFilters);
	}

	trackDefautFilters(key) {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Account,
			SUBSCOPE_TYPE.List,
			ITEM_TYPE.Filter,
			INTERACTION_TYPE.Submit,
			{
				filter: key,
			}
		);
	}

	trackBaselineLevelsFilter() {
		this.contactFilterForm.value.levels.forEach((level) => {
			this.actionTrackerService.eventTracker(
				SCOPE_TYPE.Account,
				SUBSCOPE_TYPE.List,
				ITEM_TYPE.Filter,
				INTERACTION_TYPE.Submit,
				{
					filter: 'baselineLevel:' + level,
				}
			);
		});
	}

	setPromptuaryFilter(value) {
		this.contactFilterForm.controls.hasPromptuaryRegistered.setValue(value);
	}
}
